import { render, staticRenderFns } from "./PendingRegistrationDetails.vue?vue&type=template&id=26f40b50&scoped=true"
import script from "./PendingRegistrationDetails.vue?vue&type=script&lang=js"
export * from "./PendingRegistrationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f40b50",
  null
  
)

export default component.exports